export default __webpack_public_path__ + "assets/4ab7c42f833bb98fe3b1e316a74b70a9.png";